import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { underline } from './text';
export const baseDefault = theme => ({
  color: theme.color.primary.base,
  '&:hover, &:focus': {
    color: theme.color.primary.dark
  }
});
export const base = theme => ({
  color: theme.color.primary.base + " !important",
  '&:hover, &:focus': {
    color: theme.color.primary.dark + " !important"
  }
});
export const reset = theme => ({
  color: theme.fontColor.base + " !important",
  '&:hover, &:focus': {
    color: theme.fontColor.dark + " !important"
  }
});
export const muted = theme => ({
  color: theme.fontColor.muted + " !important",
  '&:hover, &:focus': {
    color: theme.fontColor.mutedDark + " !important"
  }
});
export const heading = theme => ({
  color: theme.fontColor.heading + " !important",
  '&:hover, &:focus': {
    color: theme.fontColor.headingDark + " !important"
  }
});
export const contrast = theme => ({
  color: theme.contrast.base + " !important",
  '&:hover, &:focus': {
    color: theme.contrast.base + " !important"
  }
});
export const linkUnderline = {
  '&:hover, &:focus': _objectSpread({}, underline)
};